/**
 * Öffentlicher Markenname der Website. „EricMotors“ ist nur der interne Entwicklungsname
 * (Repository, Worker, Pakete) und erscheint nicht in der Oberfläche.
 */
export const BRAND = { prefix: 'Scheber', suffix: 'Motors', full: 'ScheberMotors' } as const;
